import { isUserLoggedIn } from 'redux/modules/sessions/selectors';
import type {
  Fetcher,
  FetcherArgs,
  PreloadOnlyFetcher,
  PreloadOnlyFetcherArgs,
} from './fetcher-types';

export function exceptWhenLoggedOut<A extends { location: Pick<Location, 'search'> }, R>(
  fetcher: (args: A) => R,
): (args: A) => R;

export function exceptWhenLoggedOut<PathParamKey extends string = string>(
  fetcher: Fetcher<PathParamKey>,
): Fetcher<PathParamKey>;

export function exceptWhenLoggedOut(fetcher: PreloadOnlyFetcher): PreloadOnlyFetcher;

export function exceptWhenLoggedOut<PathParamKey extends string = string>(
  fetcher: Fetcher<PathParamKey> | PreloadOnlyFetcher,
): Fetcher<PathParamKey> | PreloadOnlyFetcher;

export function exceptWhenLoggedOut<PathParamKey extends string = string>(
  fetcher: Fetcher<PathParamKey> | PreloadOnlyFetcher,
): Fetcher<PathParamKey> | PreloadOnlyFetcher {
  return (args: FetcherArgs<PathParamKey> | PreloadOnlyFetcherArgs) => {
    if ('preloadOnly' in args) {
      (fetcher as PreloadOnlyFetcher)(args);

      return () => {};
    }

    return (dispatch: WtrDispatch, getState: WtrGetState) => {
      if (!isUserLoggedIn(getState())) {
        return Promise.resolve();
      }

      return dispatch((fetcher as Fetcher<PathParamKey>)(args));
    };
  };
}
